<template>
  <div
    v-show="showBulkActionsPanel === true"
    class="pr-selectedRowActions mx-3 mb-1"
  >
    <v-card color="primary" dark class="pa-1">
      <v-card-actions>
        {{ selectedRows ? selectedRows.length : "" }} Ítems
        <v-spacer />
        <v-btn color="white" light small @click.stop="$emit('getCsv', true)">
          Exportar CSV
          <v-icon size="14" class="ml-2">save_alt</v-icon>
        </v-btn>
        <v-btn v-if="settings.bulk_delete" color="white" light small @click.stop="$emit('bulkDelete')">
          Eliminar
          <v-icon color="red" size="14" class="ml-2">delete_forever</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    settings: {
      type: Object,
      required: true,
    },
    selectedRows: {
      type: Array,
      default: function() {
        return []
      },
    },
    showBulkActionsPanel: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped></style>
